import React, { useContext, useEffect, useState } from "react";
import USAMap from "react-usa-map";
import { filterData } from "./DropdownFilter";
import { FilterContext } from "../context/filterContext";
import "../../../assests/css/states.scss";

export interface statesProps {
  data: filterData[];
  companyDetailId: number;
  edit: boolean;
  onChange: (
    id: number,
    action: "add" | "remove",
    data?: object
  ) => Promise<boolean>;
}

export default function States(props: statesProps) {
  const { data, companyDetailId, onChange, edit } = props;
  const { filterData } = useContext(FilterContext);
  const [states, setStates] = useState<filterData[]>([]);
  const [enableEdit, setEnableEdit] = useState(false);
  const [loading, setLoading] = useState(-1);

  const fillStates = () => {
    let statesFilled = {};
    data.forEach((state) => {
      statesFilled = {
        ...statesFilled,
        [state.value.toUpperCase()]: {
          fill: "rgba(161, 204, 127, 1)",
        },
      };
    });
    return statesFilled;
  };

  const cleanStatesFilterData = (data: filterData[]) => {
    const statesData = [...data];
    statesData.splice(0, 1);
    return statesData;
  };

  const handleEdit = (edit: boolean) => {
    if (edit) {
      setStates(cleanStatesFilterData(filterData.states));
      setEnableEdit(true);
    } else {
      setStates(data);
      setEnableEdit(false);
    }
  };

  const isStateSelected = (id: number) => {
    const isSelected = data.filter((state) => (state.id === id ? true : false));
    return isSelected.length ? true : false;
  };

  const handleRemove = async (id: number, checked: boolean) => {
    setLoading(id);
    if (checked) {
      const companyStateId = data.filter((data) => data.id === id);
      const temp = companyStateId[0].companyStateId;
      const stateId = companyStateId[0].id;
      const reqData = {
        StateId: stateId,
        CompanyDetailId: companyDetailId,
      };
      if (companyStateId.length && temp) {
        await onChange(temp, "remove", reqData);
      }
    } else {
      const data = {
        StateId: id,
        CompanyDetailId: companyDetailId,
      };
      await onChange(0, "add", data);
    }
    setLoading(-1);
  };

  useEffect(() => {
    setStates(enableEdit ? cleanStatesFilterData(filterData.states) : data);
    if (edit) {
      handleEdit(edit);
    }
  }, [data, edit]);

  return (
    <div className="states-container">
      <div className="state-names">
        {/* "All" checkbox option */}
        {edit && (
          <div className="state-details" key="state-all">
            <span className="state-name">Select</span>
            <span className="state-name">ALL</span>
            <span className="state-remove-icon">
              <input
                type="checkbox"
                checked={states.every((s) => isStateSelected(s.id))}
                disabled={loading !== -1}
                onChange={async () => {
                  const allSelected = states.every((s) =>
                    isStateSelected(s.id)
                  );

                  //   if (allSelected) {
                  //     // Deselect all selected states
                  //     for (const state of data) {
                  //       await handleRemove(state.id, true); // remove each
                  //     }
                  //   } else {
                  //     // Select all available states
                  //     for (const state of states) {
                  //       if (!isStateSelected(state.id)) {
                  //         await handleRemove(state.id, false); // add each not already selected
                  //       }
                  //     }
                  //   }
                  if (allSelected) {
                    // Deselect all instantly in UI
                    setStates([]);
                    setLoading(-2);

                    // Kick off removals in parallel (don’t block UI)
                    const promises = data.map((state) =>
                      handleRemove(state.id, true)
                    );
                    Promise.all(promises).finally(() => setLoading(-1));
                  } else {
                    // Select all instantly in UI
                    setStates(states);
                    setLoading(-2);

                    // Kick off adds in parallel
                    const promises = states
                      .filter((s) => !isStateSelected(s.id))
                      .map((state) => handleRemove(state.id, false));

                    Promise.all(promises).finally(() => setLoading(-1));
                  }

                  
                }}
              />
            </span>
          </div>
        )}
        {states.map(({ id, value, abbreviation }, index) => {
          return (
            <div className="state-details" key={`state-${id}-${index}`}>
              <span className="state-name">{value}</span>
              <span className="state-abbr">{abbreviation}</span>
              {edit ? (
                <span className="state-remove-icon">
                  {loading !== id ? (
                    <input
                      type="checkbox"
                      checked={isStateSelected(id)}
                      disabled={loading !== -1 ? true : false}
                      onChange={() => handleRemove(id, isStateSelected(id))}
                    />
                  ) : (
                    <span className="edit-loader" />
                  )}
                </span>
              ) : null}
            </div>
          );
        })}
      </div>
      <div className="states-map">
        <USAMap
          width={580}
          height={226}
          defaultFill={"rgba(248, 248, 248, 1)"}
          customize={fillStates()}
          title="USA Map"
        />
      </div>
    </div>
  );
}
